export enum voiceInstructors {
    Dave = 'Dave',
}

export interface IVoiceInstructor {
    name: string;
    image: string;
}

export class VoiceInstructorConfig {
    public static voiceInstructorList: IVoiceInstructor[] = [{
        name: voiceInstructors.Dave,
        image: 'dave-face',
    }];
}
